export default {
  HOME: "Главная",
  BUY_NOW: "Купить",
  PLAY: "Играть",
  Note: "Примечание",
  WELCOME: "Добро пожаловать в ",
  PICK_NUMBERS: "Выбрать числа",
  PROCEED_CART: "В корзину",
  PROCEED_CHECKOUT: "Оформить заказ",
  CART_TOTAL: "Итого",
  BET_TOTAL: "Сумма ставки",
  LINE: "Линия",
  PLACE_BET: "Сделать ставку",
  PRINT: "Печать",
  STAKE: "Ставка",
  LINES: "Линии",
  ADD_TO_CART: "Добавить в корзину",
  UPDATE_CART: "Обновить корзину",
  SUMMARY: "Итог",
  BACK: "Назад",
  RANDOMIZE_ALL: "Случайный выбор",
  CLEAR_ALL: "Очистить всё",
  ADD_LINE: "Добавить линию",
  LINE_NO: "Линия №",
  MY_SHOPPING_CART: "Моя корзина",
  PENCIL: "Редактировать",
  CHECKOUT_MSG_1: "Нажимая «Оплатить», вы соглашаетесь с нашими ",
  CHECKOUT_MSG_2: "Правилами и условиями",
  CHECKOUT_MSG_3: "Все транзакции производятся в USD. Цены в других валютах указаны для ознакомления.",
  DELETE: "Удалить",
  PRICE: "Цена",
  PAY: "Оплатить",
  CHECKOUT: "Оформление",
  MY_WALLET: "Мой кошелёк",
  WALLET: "Кошелёк",
  LOTTO: "Лото",
  GAMES: "Игры",
  AMOUNT: "Сумма",
  TRANSACTIONS: "Транзакции",
  ID: "ID",
  ID_TRANSACTION: "ID транзакции",
  DATE: "Дата",
  TYPE: "Тип",
  STATUS: "Статус",
  CREDIT: "Кредит",
  EDIT: "Редактировать",
  FIELD_REQUIRED: "Это поле обязательно",
  ERROR: "Ошибка",
  SUBMIT: "Отправить",
  LOTTO_GAMES: "Лото игры",
  BET_SLIP: "Квитанция",
  LOTTO_RESULTS: "Результаты лото",
  INSUFFICIENT_FUNDS: "Недостаточно средств",
  INSUFFICIENT_FUNDS_MSG: "Пополните счёт для совершения покупки.",
  CANCELED: "Отменено",
  PENDING: "В обработке",
  WITHDRAW: "Вывод",
  MY_TICKETS: "Мои билеты",
  DRAW_DATE: "Дата розыгрыша",
  BET_ID: "ID ставки",
  COST: "Стоимость",
  WINNINGS: "Выигрыш",
  NEXT: "Далее",
  TICKET: "Билет",
  TICKETS: "Билеты",
  TICKET_NUMBERS: "Числа билета",
  LOGIN: "Войти",
  LOGIN_ALT: "Войти",
  LOGOUT: "Выйти",
  NO_ITEMS_IN_CART: "Корзина пуста",
  PROFILE: "Профиль",
  BET_PLACED_MSG: "Ваш заказ оформлен!",
  PLAY_AGAIN: "Играть снова!",
  ORDER: "Заказ",
  ORDER_CONFIRMATION: "Подтверждение заказа",
  NOT_ENOUGH_BALANCE: "На вашем счёте недостаточно средств",
  NUMBERS_NOT_SELECTED_MSG: "Вы не выбрали числа. Нажмите здесь для выбора.",
  ENTER_A_NUMBER: "Введите число",
  LOADING: "Загрузка...",
  TOTAL_COST: "Итоговая стоимость",
  TOTAL: "Итого",
  PLACED: "Принято",
  LOST: "Проигрыш",
  WON: "Выигрыш",
  GROSS_WINNINGS: "Валовой выигрыш",
  OK: "Ок",
  DEBIT: "Дебет",
  LOTTO_TICKET: "Лото-билет",
  REFUND: "Возврат",
  WINNING: "Выигрыш",
  SUCCESSFUL: "Успешно",
  FAILED: "Ошибка",
  PLAY_NOW: "Играть!",
  DRAW_EVERY_5_MIN: "Розыгрыш каждые 5 минут",
  COMING_SOON: "Скоро",
  LATEST_LOTTO_RESULTS: "Последние результаты",
  SELECT_DRAW_DATE: "Дата розыгрыша",
  WINNING_NUMBERS: "Выигрышные числа",
  MIN: "Мин",
  SEC: "Сек",
  MINUTES: "Минуты",
  SECONDS: "Секунды",
  LATEST_LOTTERY_RESULTS: "Последние результаты лотереи",
  DRAW_EVERY_5_MINS: "Розыгрыш каждые 5 минут",
  SELECT_LOTTERY: "Выбрать лото",
  ALL_RESULTS: "Все результаты",
  DRAW_NUMBER: "Номер розыгрыша",
  PERSONAL_DATA: "Личные данные",
  NUMBER_OF_DRAWS: "Количество розыгрышей",
  QUICK_PICK: "Случайный выбор",
  CLEAR: "Очистить",
  FIELD: "Поле",
  SUBMIT_TICKET: "Отправить",
  ADD_ANOTHER_LINE: "Добавить линию",
  DRAW_CLOSES_IN: "Розыгрыш закрывается через",
  NO_DRAWS_FOUND: "Розыгрыши не найдены.",
  MY_BETS: "Мои ставки",
  MY_BETS_LOTTO: "Мои ставки лото",
  GAME: "Игра",
  PLACED_DATE: "Дата размещения",
  RESULT: "Результат",
  MY_NUMBERS: "Мои числа",
  DRAW: "Розыгрыш",
  PERIOD: "Период",
  QUICK_PICKS: "Быстрый выбор",
  SELECT_STAKE: "Выбрать ставку",
  DRAWS_TEXT: "Розыгрыши",
  NO_DATA_FOUND: "Данные не найдены",
  PASSWORD: "Пароль",
  EMAIL: "Email",
  FIRST_NAME: "Имя",
  LAST_NAME: "Фамилия",
  MOBILE_NUMBER: "Номер телефона",
  REGISTER: "Зарегистрироваться",
  CREATE_ACCOUNT: "Создать аккаунт",
  FORGOT_PASSWORD: "Забыли пароль?",
  SIGN_IN: "Войти",
  SIGN_UP: "Регистрация",
  CONTINUE: "Продолжить",
  ALREADY_REGISTERED: "Уже есть аккаунт?",
  LOGIN_HERE: "Войдите здесь.",
  SEND_OTP: "Отправить код",
  VERIFY_OTP: "Подтвердить код",
  ENTER_CODE: "Введите код",
  VERIFY: "Подтвердить",
  RESET_PASSWORD: "Сбросить пароль",
  SET_PASSWORD: "Установить пароль",
  CONFIRM_PASSWORD: "Подтвердить пароль",
  COPY: "Копировать",
  DONE: "Готово",
  SEARCH_CRYPTO_EXCHANGE_OFFICES: "Поиск крипто-обменников",
  DEPOSIT: "Пополнить",
  DEPOSIT_NOW: "Пополнить сейчас",
  DEPOSIT_AMOUNT: "Сумма пополнения",
  PROMOTIONS: "Акции",
  HOW_TO_PLAY: "Как играть",
  PROCESSING_PAYMENT: "Обработка платежа",
  PRIVACY_POLICY: "Политика конфиденциальности",
  TERMS_CONDITION: "Условия и положения",
  DATA_NOT_AVAILABLE: "Данные недоступны.",
  SINGLE_LOTTERY_BET_AMOUNT: "Сумма ставки",
  TOTAL_WINNINGS: "Общий выигрыш",
  TICKET_NUMBER: "Номер билета",
  SELLER: "Продавец",
  PURCHASE_DATE: "Дата покупки",
  ERROR_EMAIL_PASSWORD: "Ошибка: неверный email или пароль",
  PASSWORDS_DONT_MATCH: "Пароли не совпадают",
  USER_NOT_FOUND: "Аккаунт не найден",
  ACCOUNT_ALREADY_EXISTS: "Аккаунт уже существует",
};
